<template>
    <div>
        <div v-if="!ticketCreated">
            working, please wait...
        </div>
        <div v-else>
            Please close this window
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  layout: 'plain',
  data: () => ({
    ticketCreated: false
  }),
  mounted() {
    let ticket = this.$route.params.ticket
    axios.post(`/api/ticket/${ticket}`).then((response) => {
        this.ticketCreated = true
    })
  },
  methods: {
    closeWindow() {
        window.close()
    }
  }
}
</script>